<div class="p-grid">
	<div class="p-col-12 p-md-9">
		<div class="d-flex flex-fill flex-column">
			<div class="d-flex flex-column">
				<div class="p-grid">
					<div class="p-col p-text-bold">Menu Name</div>
					<div class="p-col d-flex justify-content-end">
						{{ menuItem.name }}
					</div>
				</div>
				<div class="p-grid">
					<div class="p-col p-text-bold">Remote Name</div>
					<div class="p-col d-flex justify-content-end">
						<p-skeleton *ngIf="!menuItemRecord"></p-skeleton>
						{{ menuItemRecord?.RemoteName }}
					</div>
				</div>
				<div class="p-grid">
					<div class="p-col p-text-bold">POS ID</div>
					<div class="p-col d-flex justify-content-end">
						{{ menuItem.menuItemId }}
					</div>
				</div>
				<div class="p-grid">
					<div class="p-col p-text-bold">Internal ID</div>
					<div class="p-col d-flex justify-content-end">
						{{ menuItem.menuItemKey }}
					</div>
				</div>
				<div class="p-grid">
					<div class="p-col p-text-bold">Report Group</div>
					<div class="p-col d-flex justify-content-end">
						<p-skeleton *ngIf="!menuItemRecord"></p-skeleton>
						{{ menuItemRecord?.ReportGroupRecord.Name }}
					</div>
				</div>
				<div class="p-grid">
					<div class="p-col p-text-bold">Item Type</div>
					<div class="p-col d-flex justify-content-end">
						<p-skeleton *ngIf="!menuItemRecord"></p-skeleton>
						<span *ngIf="menuItemRecord?.Type === 0">Food</span>
						<span *ngIf="menuItemRecord?.Type === 1">Bar</span>
						<span *ngIf="menuItemRecord?.Type === 2">Other</span>
					</div>
				</div>
				<div class="p-grid">
					<div class="p-col p-text-bold">Stock Status</div>
					<div class="p-col d-flex justify-content-end">
						<fa-icon [icon]="['far', 'check']" *ngIf="!menuItem.outOfStock"></fa-icon>
						<fa-icon [icon]="['far', 'times']" *ngIf="menuItem.outOfStock"></fa-icon>
					</div>
				</div>
				<div class="p-grid">
					<div class="p-col p-text-bold">Countdown Item</div>
					<div class="p-col d-flex justify-content-end">
						<p-skeleton *ngIf="!menuItemRecord"></p-skeleton>
						<fa-icon [icon]="['far', 'check']" *ngIf="menuItemRecord?.Countdown"></fa-icon>
						<fa-icon [icon]="['far', 'times']" *ngIf="!menuItemRecord?.Countdown"></fa-icon>
					</div>
				</div>
			</div>
			<div class="d-flex">
				<div class="h4 ms-1 mt-2 mb-1">Tags</div>
			</div>
			<p-divider></p-divider>
			<p-dropdown
				placeholder="Add an item tag..."
				[options]="venueService.ooTags"
				optionValue="key"
				optionLabel="name"
				(onChange)="ooMenuItemTagSelect($event, menuItem.menuItemKey)"
				[style]="{ width: '100%' }"
				appendTo="body"
			>
			</p-dropdown>
			<div class="d-flex">
				<div *ngFor="let tag of menuItem.OOMenuItemTags">
					<p-tag
						[value]="tag.OOTags.name"
						styleClass="oo-tag-display m-2"
						[severity]="tag.OOTags.severity"
						[rounded]="true"
						(click)="ooMenuItemTagRemove(tag.tagKey, tag.menuItemKey)"
						pTooltip="Click to remove"
					>
					</p-tag>
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-3">
		<div class="d-flex">
			<div class="mx-auto">
				<img
					*ngIf="!menuItem.imageKey"
					[ngClass]="venueService.subscriptionOOStyles.value.menuItemBoxShadow ? 'product-image' : 'product-image-no-shadow'"
					[src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/no-image-found-360x250.png?' + timestamp"
					style="max-width: 200px; height: auto"
				/>
				<div *ngIf="!menuItem.imageKey"></div>
				<img
					*ngIf="menuItem.imageKey"
					[ngClass]="venueService.subscriptionOOStyles.value.menuItemBoxShadow ? 'product-image' : 'product-image-no-shadow'"
					[src]="
						'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' +
						venueService.venueKey +
						'/' +
						menuItem.menuItemKey +
						'.png?' +
						timestamp
					"
					style="max-width: 200px; height: auto"
				/>
			</div>
		</div>

		<div class="d-flex w-100 flex-wrap mt-2">
			<div class="mx-auto">
				<p-button pRipple styleClass="p-button-raised p-button-primary m-2" (click)="selectMenuItemImage(menuItem.menuItemKey)">
					<ng-template pTemplate="content">
						<div class="d-flex justify-content-center">
							<div class="my-auto">
								<fa-icon [icon]="['far', 'camera']" size="lg" class="ms-1 me-2"></fa-icon>
							</div>

							Attach Pic
						</div>
					</ng-template>
				</p-button>
			</div>
			<div class="mx-auto">
				<p-button pRipple styleClass="p-button-raised p-button-danger m-2" (click)="menuItemImageDelete(menuItem)">
					<ng-template pTemplate="content">
						<div class="d-flex justify-content-center">
							<div class="my-auto">
								<fa-icon [icon]="['far', 'camera-slash']" size="lg" class="ms-1 me-2"></fa-icon>
							</div>

							Remove Pic
						</div>
					</ng-template>
				</p-button>
			</div>
		</div>
	</div>
</div>
